export default function RightMainContainer({ className, children }) {
  return (
    <>
      <div className={`flex flex-col ${className ?? ""} relative`}>
        {children}
      </div>
    </>
  );
}
